export default __webpack_public_path__ + "static/media/prevencao.c589b98d.jpg";